import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TrackingService } from 'src/app/core/services/api/tracking.service';
import { CookieBannerModalComponent } from './cookie-banner-modal/cookie-banner-modal.component';

@Injectable({
  providedIn: 'root',
})
export class CookieBannerService {
  constructor(
    private modalService: NgbModal,
    private trackingService: TrackingService
  ) {}

  /**
   * Toont de cookie-banner alleen als de gebruiker nog geen keuze heeft gemaakt.
   * Deze methode wordt aangeroepen bij het initialiseren van de app.
   */
  public showBannerIfNeeded(): void {
    const cookieChoiceMade = localStorage.getItem('cookie-accepted') !== null;
    if (!cookieChoiceMade) {
      this.openCookieModal();
    }
  }

  /**
   * Opent de cookie modal. Deze methode is publiek zodat elke component
   * (zoals de footer) hem kan aanroepen om de instellingen te wijzigen.
   */
  public openCookieModal(): void {
    const modalRef = this.modalService.open(CookieBannerModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.result.then(
      (accepted) => {
        localStorage.setItem('cookie-accepted', accepted.toString());

        if (accepted) {
          this.trackingService.userGaveConsent();
        } else {
          // Als een gebruiker expliciet afwijst, moet tracking worden uitgeschakeld.
          // Dit wordt afgehandeld door de setConsentStatus in de tracking service.
          // We kunnen hier een expliciete 'revoke' methode aanroepen voor directheid.
          this.trackingService.userRejectedConsent();
        }
      },
      () => {
        // Modal werd gesloten zonder keuze (bv. door weg te navigeren).
        // Behandel als afwijzing als er nog geen keuze was.
        if (localStorage.getItem('cookie-accepted') === null) {
          localStorage.setItem('cookie-accepted', 'false');
        }
      }
    );
  }
}
